import {
  HR_BOT_APP_ID,
  LAUNCHER_APP_ID,
  OMMNIO_BOT_APP_ID,
  TIME_TRACKING_APP_ID,
  WHISTLEBLOWER_BOT_APP_ID,
} from 'services/constants';
import { apiUrl } from 'services/apiBaseUrl';

const openAppConfig = (actions, appId) => () => {
  if (appId === HR_BOT_APP_ID) {
    return actions.drawers.hrBot.open();
  }
  if (appId === WHISTLEBLOWER_BOT_APP_ID) {
    return window.open('/wb-admin', '_blank');
  }
  if (appId === TIME_TRACKING_APP_ID) {
    return actions.drawers.timeTracking.open();
  }
  if (appId === LAUNCHER_APP_ID) {
    return actions.drawers.launcherApp.open();
  }
  if (appId === LAUNCHER_APP_ID) {
    return actions.drawers.launcherApp.open();
  }
  if (appId === OMMNIO_BOT_APP_ID) {
    return actions.drawers.ommnioBot.open();
  }
  return actions.drawers.remote.open(apiUrl(`/v1/app/${appId}/config`));
};

export default openAppConfig;
